let parser = new window.DOMParser();
function svgParser(svgString) {
    let svgEl = parser.parseFromString(svgString, 'image/svg+xml');
    return svgEl.documentElement || svgEl;
}

export { svgParser };